/**
 * Replace template by vars
 * @param {string} template - Template string
 * @param {Object} [templateVars] - Template vars
 * @returns {String}
 */
export default function replaceTemplateByVars(template, templateVars = {}) {
    const entries = Object.entries(templateVars);
    const firstEntry = entries[0];

    if (!firstEntry) return template;

    const [varName, varValue] = firstEntry;
    const replacedTemplate = template.replace(`\${${varName}}`, varValue);
    const ifVarStillExists = replacedTemplate.indexOf(`\${${varName}}`) !== -1;
    const newVars = ifVarStillExists ? entries : entries.slice(1);

    return replaceTemplateByVars(replacedTemplate, Object.fromEntries(newVars));
}
